import { Location, WindowLocation } from "@reach/router";
import queryString from "query-string";
import React from "react";

import { NonIdealState } from "@blueprintjs/core";
import { AudienceView, PerformerView } from "../components/performance";
import { default as DefaultLayout } from "../layouts";

interface UrlParams {
    roomName?: string;
    performerId?: number;
}

export default class extends React.Component {
    public readonly displayName = "PerformancePage";

    public render() {
        return (
            <Location>
                {({ location }) => {
                    const { roomName, performerId } = this.getUrlParams(location);
                    return (
                        <DefaultLayout>
                            {roomName === undefined ? (
                                <NonIdealState
                                    title="Performance not found"
                                    description="No room found with the name specified in the URL"
                                />
                            ) : performerId === undefined ? (
                                <AudienceView roomName={roomName} />
                            ) : (
                                <PerformerView roomName={roomName} performerId={performerId} />
                            )}
                        </DefaultLayout>
                    );
                }}
            </Location>
        );
    }

    private getUrlParams(location: WindowLocation): UrlParams {
        const { room, performerId } = queryString.parse(location.search);
        return {
            roomName: typeof room === "string" ? room : undefined,
            performerId: typeof performerId === "string" ? parseInt(performerId, 10) : undefined,
        };
    }
}
